import { createRouter, createWebHashHistory } from 'vue-router'
import { fetchAuthSession, fetchUserAttributes } from 'aws-amplify/auth'
import store from '../store'
import LoginPage from '../views/MainPage/LoginPage.vue'
import LandingPage from '../views/LandingPage.vue'

const routes = [
  {
    path: '/',
    name: 'login',
    component: LoginPage
  },
  {
    path: '/home',
    name: 'home',
    component: LandingPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

async function restoreCognitoSession() {
  if (store.getters.isLoggedIn) return true

  try {
    const session = await fetchAuthSession()
    if (!session?.tokens) return false

    const attributes = await fetchUserAttributes()
    const email = attributes?.email
    if (email) {
      store.dispatch('login', email)
      return true
    }
  } catch (error) {
    return false
  }

  return false
}

router.beforeEach(async (to) => {
  const loggedIn = store.getters.isLoggedIn || (await restoreCognitoSession())

  if (to.meta.requiresAuth && !loggedIn) {
    return { name: 'login' }
  }

  if (to.name === 'login' && loggedIn) {
    return { name: 'home' }
  }

  return true
})

export default router
